import { Box, Card, CardBody, Spinner } from "grommet";
import { Outlet } from "react-router-dom";
import { BoxWindow } from "../components/BoxWindow";
import { Currency, Plan } from "grommet-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import RouletteSVG from "../icons/RouletteSVG";
import SidebarComponent from "../components/layout/SidebarComponent";

export const DashboardPage = () => {

	const { t, i18n, ready } = useTranslation("dashboard", {
		useSuspense: false,
	});
	const [menuItems] = useState([
		{
			title: "dashboard:eventsTitle",
			icon: <Plan />,
			link: "/dashboard/events",
		},
        {
			title: "dashboard:roulette",
			icon: <RouletteSVG style={{ display: 'inline-box', flex: '0 0 auto' }} />,
			link: "/dashboard/roulette",
		},
		{
			title: "dashboard:paymentsHistoryTitle",
			icon: <Currency />,
			link: "/dashboard/payments-history",
		},
	]);

	if (!ready) {
		return <Spinner />;
	}

	return (
		<BoxWindow topPadding>
			<Box direction="row" gap={"medium"} fill>
				<Card>
					<CardBody>
						<SidebarComponent navs={menuItems} />
					</CardBody>
				</Card>
				<Box flex>
					<Outlet />
				</Box>
			</Box>
		</BoxWindow>
	);
};
